import { createCustomPortalApi } from 'api/rtkQueryApi';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from 'utils/getAccessToken';

import { env } from 'env';

const baseQuery = fetchBaseQuery({
  baseUrl: env.REACT_APP_API_URL,
  prepareHeaders: async (headers) => {
    const accessToken = await getAccessToken();

    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }

    return headers;
  },
});

export const customPortalApi = createCustomPortalApi(baseQuery).enhanceEndpoints({
  endpoints: {
    accountCreatePost: {
      invalidatesTags: ['PrequalificationGetResponseType'],
    },
    offersOnlinePost: {
      invalidatesTags: ['PrequalificationGetResponseType'],
    },
    applicationsApplicationidCalculateLoanPost: {
      async onQueryStarted(options, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(customPortalApi.util.invalidateTags(['ApplicationInformation']));
        } catch {
          console.log('Error');
        }
      },
      invalidatesTags: [],
    },
  },
});

export const {
  usePrequalificationGetQuery,
  useOffersOnlinePostMutation,
  useAccountCreatePostMutation,
  useOffersBranchPostMutation,
  useAccountVerifyCodePostMutation,
  useAccountSendVerificationCodePostMutation,
  useBorrowerSearchPostMutation,
  useApplicationsApplicationidGetQuery,
  useApplicationsApplicationidSaveEcoaConsentPostMutation,
  useApplicationsApplicationidBankVerificationSkipPostMutation,
  useApplicationsApplicationidBankVerificationVerifyPostMutation,
  useApplicationsApplicationidBankVerificationReviewBankInformationManualyPostMutation,
  useApplicationsApplicationidSaveIncomeSourcesPostMutation,
  useApplicationsApplicationidDocumentRequirementsGetQuery,
  useApplicationsApplicationidCompleteIncomeVerificationPostMutation,
  useApplicationsApplicationidSubmitPostMutation,
  useApplicationsApplicationidCounterOfferAcceptPostMutation,
  useApplicationsApplicationidCounterOfferDeclinePostMutation,
  useApplicationsApplicationidCalculateLoanPostMutation,
  useHellosigndocPostMutation,
  useApplicationsApplicationidCompleteDocumentsSigningPostMutation,
} = customPortalApi;
